import 'intersection-observer'

window.addEventListener('load', () => {
  const floatBanner = document.querySelector('.js-floating-banner')
  const actButtonTop = document.querySelector('.js-act-button-top')
  const copyright = document.querySelector('.js-copyright')
  let prevRatio = 1

  if (!floatBanner) {
    copyright.style.marginBottom = '0'
    return
  }

  const io = new IntersectionObserver(callback)

  if (actButtonTop) {
    io.observe(actButtonTop)
  } else {
    floatBanner.classList.add('fade-in')
  }

  function callback (entries) {
    entries.forEach((entry) => {
      floatBanner.classList.add('fade-in')

      if (entry.intersectionRatio > prevRatio ||
          entry.boundingClientRect.y >= 0) {
        floatBanner.classList.remove('fade-in')
        return
      }

      prevRatio = entry.intersectionRatio
    })
  }
})
